/* Format a staff member's name: Display Name, else legal "First Last".
   Expects the raw providers.displayName, not an attendee's generated label.
   Kept free of imports so it can be used without utils/format's import cycle */
export const formatProviderName = provider =>
  provider?.displayName?.trim() ||
  [provider?.firstName, provider?.lastName]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(' ') ||
  provider?.name?.trim() ||
  '';
